module.exports = __webpack_public_path__ + "static/media/rarestone.63ab85ec.svg";